
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ActivityHeader extends Vue {
  @Prop({ default: '' }) readonly title!: string;
}
